module.exports = __webpack_public_path__ + "img/notification.1d080669.svg";